/**
 * @voltxampere/ui — BSS138 NMOS logic-level MOSFET variant (Sprint 38-2)
 *
 * Reference: onsemi BSS138 datasheet (SOT-23 logic-level NMOS).
 *   Vt0 = 1.5 V         (low V_th — gate logic-level compatible)
 *   Kp  = 0.05 A/V²
 *   Lambda = 0.002 1/V
 *
 * Yaygın level-shifter / logic-gate MOSFET. SOT-23 surface-mount,
 * R_th = 600 °C/W (Sprint 38-5 R_thermal entry).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { nmos } from "../nmos.js";
export const mosfetNmosBss138 = {
    id: "bss138",
    nameTr: "BSS138 (NMOS lojik, SOT23)",
    nameEn: "BSS138 (NMOS logic-level, SOT23)",
    shortcut: "M",
    category: "active",
    viewBox: nmos.viewBox,
    terminals: nmos.terminals,
    defaultLabel: "M",
    defaultValue: "BSS138",
    schemaType: "mosfet-nmos",
    defaultParams: { Vt0: 1.5, Kp: 0.05, Lambda: 0.002 },
    renderSVG: () => nmos.renderSVG(),
};
//# sourceMappingURL=mosfet-nmos-bss138.js.map